import script from "./StepsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./StepsSection.vue?vue&type=script&setup=true&lang=js"

import "./StepsSection.vue?vue&type=style&index=0&id=d39ff2da&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d39ff2da"]])

export default __exports__